module.exports = __webpack_public_path__ + "static/media/v1504_v0.4.dc1b1fa0.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/Media/v1504_v0.4.pdf
// module id = 258
// module chunks = 0